<script setup lang="ts">
definePageMeta({
  middleware: async (route) => {
    const industrySlug = route.params.industry as string

    const { data: allSlugs } = await useFetch(
      '/api/items/industries',
      {
        key: 'midd:industry-slugs',
        query: {
          fields: ['slug'],
          filter: {
            status: { _eq: 'published' },
          },
        },
        transform: (theSlugs: Pick<Industry, 'slug'>[]) => theSlugs.map(industry => industry.slug),
        getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key],
      },
    )

    // const allSlugs = await $fetch<Pick<Industry, 'slug'>[]>('/api/items/industries', {
    //   query: {
    //     fields: ['slug'],
    //     filter: {
    //       status: { _eq: 'published' },
    //     },
    //   },
    // }).then(theSlugs => theSlugs.map(industry => industry.slug))

    if (!allSlugs.value?.includes(industrySlug)) {
      return navigateTo('/industries', {
        redirectCode: 301,
      })
    }
  },
})

const route = useRoute()

const config = useRuntimeConfig()

const { theNav } = useNav()

const { data: industry } = await useFetch<Industry>(
  `/api/items/industries/${route.params.industry}`,
  {
    key: `page:${route.params.industry}:industry`,
    getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key],
  },
)

const menu = computed(() => theNav.value?.index.industries?.children?.map(industryName => theNav.value?.index[industryName]).filter((industry): industry is NavItem => !!industry))

useSeoMeta({
  title: () => industry.value?.page_title || 'ICS Industry',
  twitterTitle: () => industry.value?.page_title || 'ICS Industry',
  description: () => industry.value?.description,
  twitterDescription: () => industry.value?.description,
})
</script>

<template>
  <PageRoot v-if="industry">
    <PageHead theme="dark">
      <template #heading>
        <BlockContent>
          <TheBreadcrumbs />
          <NuxtLink to="/industries">
            <div class="page-title inline-block">
              Industries
            </div>
          </NuxtLink>
          <ANav
            :menu
            size="large"
            inline
            class="my-4 drop-shadow"
          />
        </BlockContent>
      </template>
      <template #parallax>
        <div class="bg-icsblue/63 absolute-inset mix-blend-multiply -z-1" />
        <div class="absolute-inset from-white/62 to-white/38 bg-linear-to-b -z-2" />
        <div class="bg-icsblue absolute-inset mix-blend-overlay -z-2" />
        <video
          autoplay
          loop
          muted
          playsinline
          class="absolute-inset object-cover size-full -z-3"
          :poster="`${config.public.directusUrl}/assets/${industry.video_poster}`"
        >
          <source
            :src="`${config.public.directusUrl}/assets/${industry.video_webm}`"
            type="video/webm"
          >
          <source
            :src="`${config.public.directusUrl}/assets/${industry.video_mp4}`"
            type="video/mp4"
          >
        </video>
      </template>
    </PageHead>
    <PageBody>
      <BlockContent element="section">
        <h1 class="subpage-title mb-10 hyphens-manual sm:hyphens-none">
          {{ industry.page_title }}
        </h1>
        <ul class="text-lg list-disc list-inside marker:text-icsred">
          <li
            v-for="bullet in industry.examples"
            :key="bullet"
            v-html="bullet"
          />
          <li>&amp; More</li>
        </ul>
        <TopLevelButtons class="my-8" />
        <div
          v-if="industry.content"
          class="prose"
          v-html="industry.content"
        />
        <TopLevelButtons
          v-if="industry.content"
          class="my-8"
        />
      </BlockContent>
    </PageBody>
  </PageRoot>
</template>
